import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsFullscreen } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-fullscreen.icon';
import { kzIconsCross } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon';

@Component({
  selector: 'app-fullscreen-button',
  templateUrl: './fullscreen-button.component.html',
  styleUrls: ['./fullscreen-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullscreenButtonComponent implements OnInit {

  @Output() public toggleFullscreen = new EventEmitter();

  @Input() public fullScreenIsOpened = false;

  @HostListener('click', ['$event'])
  onButtonClick($event) {
    this.fullScreenIsOpened = !this.fullScreenIsOpened;
    this.toggleFullscreen.emit(this.fullScreenIsOpened);
  }

  constructor(
    public elRef: ElementRef,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsFullscreen, kzIconsCross]);
  }

  ngOnInit() {
  }

}
